import get from 'lodash/get'
import alertMutations, { getErrorMessage, formatAlert } from 'optinmonster-js-library/src/vue/campaigns/store/alerts/mutations'

const maybeAddVerifyMeta = payload => {
	if ('omapp_wrong_site' === get(payload, 'response.body.code')) {
		payload = {
			closes      : false,
			explanation : '<span class="omapi-alert__primary">Site Error, Action Required:</span><br>',
			message     : get(payload, 'response.body.message', {}),
			meta        : get(payload, 'response.body.data.site', {}),
		}
		payload.meta.verifySiteChange = true
	}

	return payload
}

const clonedMutations = { ...alertMutations }

clonedMutations.addError = function (state, payload) {
	alertMutations.addError(state, maybeAddVerifyMeta(payload))
}

clonedMutations.maybeAddError = function (state, payload) {
	alertMutations.maybeAddError(state, maybeAddVerifyMeta(payload))
}

clonedMutations.setError = function (state, payload) {
	clonedMutations.addError(state, payload)
	state.error = true
}

export { getErrorMessage, formatAlert }

export default clonedMutations
